import React, {useState, useEffect, useRef, useCallback, useReducer, useMemo} from 'react';
import styled from 'styled-components';
import TeacherTemplate from "../templates/TeacherTemplate";
import LottieLoader from "../loaders/LottieLoader";

import loader_json from '../../assets/lottie/under_construction.json'
import AllDrochkaExercisesPanel from "../drochka_exercise/panels/AllDrochkaExercisesPanel";
import AllVideoMaterialsPanel from "../materials/panels/AllVideoMaterialsPanel";
import IdiomsPanel from "../idioms/panels/IdiomsPanel";
import AllWordsPanel from "../idioms/panels/AllWordsPanel";
import { translate } from '../../utils/Translate';

export default function TeacherMaterialsApp(props) {
    const [tab, setTab] = useState('my');

    return (
        <TeacherTemplate active={'materials'}>

            <TopPlaceholder>
                <TopLeft>
                    {
                        [
                            {
                                label: translate('my_videos'),
                                value: 'my'
                            },
                            {
                                label: translate('all_videos'),
                                value: 'buffer'
                            },

                            {
                                label: translate('idioms'),
                                value: 'idioms'
                            },

                            {
                                label: translate('dictionary'),
                                value: 'dictionary'
                            }

                            // {
                            //     label: 'Все материалы',
                            //     value: 'public'
                            // }
                        ].map((x, i) => {
                            return (
                                <TopRightTabItem selected={(x.value == tab)} key={i} onClick={() => {
                                    setTab(x.value);
                                }}>
                                    {x.label}
                                </TopRightTabItem>
                            )
                        })
                    }
                </TopLeft>
                <TopRight>

                </TopRight>
            </TopPlaceholder>

            <Wrapper key={tab}>

                {(tab == 'idioms' || tab == 'dictionary') ? null :
                    <AllVideoMaterialsPanel
                        mode={tab}
                    />
                }

                {tab != 'idioms' ? null :
                    <IdiomsPanel/>
                }

                {tab != 'dictionary' ? null :
                    <AllWordsPanel/>
                }



            </Wrapper>


        </TeacherTemplate>
    );
}

const Wrapper = styled.div`
  box-sizing: border-box;
  padding: 20px;
  
  @media (max-width: 720px) {
    height: 95vh;
    overflow-y: auto;
  }
`;

const TabsPlaceholder = styled.div`
  box-sizing: border-box;
  //padding: 15px;
`;


const TopPlaceholder = styled.div`
  background: white;
  height: 70px;
  //margin-bottom: 30px;
  box-sizing: border-box;
  padding-left: ${props => (props.hasLogo ? 0 : 15)}px;
  padding-right: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const TopLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 1200px) {
    font-size: 12px;
  }
`;

const TopRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ConstructionPlaceholder = styled.div`
  height: 80vh;
  text-align: center;
`;

const TopRightTabItem = styled.div`
  margin-left: 15px;
  margin-right: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${props => (props.selected == true ? '#085BFF' : 'black')};
  cursor: ${props => (props.selected == true ? 'default' : 'pointer')};
  font-weight: ${props => (props.selected == true ? 'bold' : 'normal')};
  border-bottom: 6px solid ${props => (props.selected == true ? '#FFA71B' : 'white')};
  border-top: 6px solid white;
  box-sizing: border-box;
  height: 70px;

  @media (max-width: 1200px) {
    font-size: 12px;
    margin-left: 10px;
    margin-right: 10px;
  }

  :last-of-type {

  }

  :hover {
    color: #085BFF;
  }
`;